import { isUndefined } from 'lodash-es';
import { useNavigate } from 'react-router';

import { generateWorkflowPath } from '~/core/application/routing/generateWorkflowPath';
import { useWorkflowSession } from '../../../contexts/WorkflowSessionContext';
import { useEventHandler } from '../../useEventHandler';

export const useNavigateToPlaceInWorkflow = () => {
  const { rootDocument, workflowName, targetPlace } = useWorkflowSession();
  const navigate = useNavigate();

  return useEventHandler((place?: string): void => {
    const resolvedPlace = place ?? targetPlace;
    if (isUndefined(rootDocument)) {
      throw new Error(
        'Cannot navigate to place in workflow: root document is missing',
      );
    }
    if (!resolvedPlace) {
      throw new Error('Cannot navigate to place in workflow: place is missing');
    }
    navigate(
      generateWorkflowPath(rootDocument.shortId, workflowName, resolvedPlace),
    );
  });
};
